export enum AuditTrailAction {
  Undefined = 0,

  StorageAreaApiCreate = 100,
  StorageAreaApiUpdate = 101,
  StorageAreaApiDelete = 102,
  StorageAreaApiUndoDelete = 103,

  ShapeApiCreate = 200,
  ShapeApiUpdate = 201,
  ShapeApiDelete = 202,
  ShapeApiUndoDelete = 203,

  ProductApiCreate = 300,
  ProductApiDelete = 301,
  ProductApiUpdate = 302,

  VehicleApiCreate = 400,
  VehicleApiUpdate = 401,
  VehicleApiDelete = 402,

  InventoryApiExecute = 500,
  InventoryApiUndo = 501,

  LogSorterApiCreate = 600,
  LogSorterApiDelete = 601,
  LogSorterApiUpdate = 602,

  MapStyleApiCreate = 700,
  MapStyleApiDelete = 701,
  MapStyleApiUpdate = 702,

  MoveApiUndo = 802,
  MoveApi = 803,

  SyncMove = 900,
  SyncInventory = 901,
  SyncProduct = 902,
  SyncShape = 903,
  SyncStorageArea = 904,
  SyncUndoMove = 905,
  SyncUndoInventory = 906,
  SyncUndoStorageArea = 907,
  SyncSetting = 908,
  SyncLogSorter = 909,
  SyncMapStyle = 910,
  SyncVehicle = 911,
  SyncFeatureFlag = 912,

  CoilApiCreate = 1000,
  CoilApiUpdate = 1001,
  CoilApiDelete = 1002,

  SettingUpdate = 1100,

  FeatureFlagApi = 1200,

  ProductGroupApiCreate = 1300,
  ProductGroupApiUpdate = 1301,
  ProductGroupApiDelete = 1302,
  ProductGroupSync = 1303,

  DashboardCreate = 1400,
  DashboardUpdate = 1401,
  DashboardDelete = 1402,

  ProductionOrderCreate = 1500,
  ProductionOrderUpdate = 1501,
  ProductionOrderDelete = 1502,
  ProductionOrderChange = 1503,
  ProductionOrderSync = 1505,

  MoveTimberFromLogSorterBins = 1600,
}
